*:focus {
  box-shadow: var(--shadow-focus-primary);
  outline: none !important;
}

ul {
  overflow: hidden;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0 calc(var(--space-unit) * 2);
  color: var(--color-primary01);
  font-family: var(--font-family-sans);
  list-style: none;
}

ul > li {
  padding-left: 10px;
  text-indent: -10px;
}

ul > li > a {
  display: block;
  padding-top: calc(var(--space-unit) * 0.5);
  color: var(--color-primary01);
  font-size: 14px;
  font-weight: var(--font-sb);
  letter-spacing: 0.16px;
  line-height: calc(var(--space-unit) * 2.5);
  text-decoration: none;
}

ul > li > a::before {
  padding-right: 5px;
  content: "•";
}

ul > li > span {
  padding: 0 calc(var(--space-unit) * 2);
  color: var(--color-surface04);
  font-size: 14px;
  font-weight: var(--font-rg);
  letter-spacing: 0.16px;
  line-height: calc(var(--space-unit) * 2.5);
  text-decoration: none;
}
